<template>
  <div class="subject-selector">
    <el-popover
      placement="bottom"
      trigger="click"
      popper-class="subject-popover"
      :visible-arrow="false"
      v-model="popoverVisible"
    >
      <div class="subject-list">
        <!-- <div
          class="subject-item"
          :class="{ active: selectedSubject === 0 }"
          @click="selectSubject({ key: 0 })"
        >
          全部
        </div> -->
        <div
          v-for="(item, index) in subjectList"
          :key="item.key"
          class="subject-item"
          :class="{
            active: selectedSubject === item.key,
            noMargin: index === subjectList.length - 1,
          }"
          @click="selectSubject(item)"
        >
          {{ item.value }}
        </div>
      </div>
      <div slot="reference" class="subject-trigger">
        <span class="subject-label" :class="{ 'subject-label-active': selectedSubject !== 0 }">
          {{ selectedSubjectName }}
        </span>
        <i
          class="sel-arrow"
          :class="{
            'el-icon-caret-top': popoverVisible,
            'el-icon-caret-bottom': !popoverVisible,
          }"
        ></i>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'SubjectSelector',
  props: {
    // 可以通过 props 传入初始选中的学科
    initialSubject: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedSubject: this.initialSubject,
      popoverVisible: false,
      subjectList: [],
    };
  },
  computed: {
    // 计算属性，根据 selectedSubject 返回对应的学科名称
    selectedSubjectName() {
      if (this.selectedSubject === 0) {
        return '学科';
      }
      const subject = this.subjectList.find((item) => item.key === this.selectedSubject);
      return subject ? subject.value : '';
    },
  },
  async mounted() {
    // 初始化选中的学科
    const data = await this.$http.get('/backend-api/app/study/subjectList', {});
    this.subjectList = [{ key: 0, value: '全部' }, ...data];
    // setTimeout(() => {
    //   this.subjectList = [
    //     { key: 0, value: '全部' },
    //     { key: 1, value: '语文' },
    //     { key: 2, value: '数学' },
    //     { key: 3, value: '英语' },
    //     { key: 4, value: '物理' },
    //     { key: 6, value: '化学' },
    //   ];
    // }, 1000);
  },
  methods: {
    selectSubject(subject) {
      this.selectedSubject = subject.key;
      this.popoverVisible = false;
      // 向父组件发送选中的学科
      this.$emit('subject-change', subject);
    },
    // 添加新方法，用于滚动到选中的元素
    scrollToActiveItem() {
      this.$nextTick(() => {
        const container = document.querySelector('.subject-list');
        const activeItem = container?.querySelector('.subject-item.active');

        if (container && activeItem) {
          // 检查元素是否在可视区域内
          const containerRect = container.getBoundingClientRect();
          const activeItemRect = activeItem.getBoundingClientRect();

          // 元素顶部在容器顶部以上，或元素底部在容器底部以下时需要滚动
          if (
            activeItemRect.top < containerRect.top ||
            activeItemRect.bottom > containerRect.bottom
          ) {
            if (activeItem.scrollIntoView) {
              // 滚动到元素位置，使其在容器中可见
              activeItem.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            } else {
              const offsetTop = activeItem.offsetTop - container.offsetTop;

              // 使用scrollTop属性进行滚动（更兼容的方式）
              // 将元素滚动到容器中间位置
              const scrollPosition =
                offsetTop - container.clientHeight / 2 + activeItem.clientHeight / 2;

              // 平滑滚动的兼容实现
              this.smoothScroll(container, container.scrollTop, scrollPosition, 300);
            }
          }
        }
      });
    },
    smoothScroll(element, start, end, duration) {
      // 如果浏览器支持原生的平滑滚动，直接使用
      if ('scrollBehavior' in document.documentElement.style) {
        element.scrollTop = end;
        return;
      }

      // 否则使用JS实现平滑滚动
      const startTime = performance.now();

      function scroll(timestamp) {
        const currentTime = timestamp - startTime;
        const progress = Math.min(currentTime / duration, 1);

        // 使用缓动函数使滚动更自然
        const easeInOutQuad = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);
        const value = start + (end - start) * easeInOutQuad(progress);

        element.scrollTop = value;

        if (currentTime < duration) {
          window.requestAnimationFrame(scroll);
        }
      }

      window.requestAnimationFrame(scroll);
    },
  },
  watch: {
    // 监听popover的显示状态
    popoverVisible(newVal) {
      if (newVal) {
        // 当popover显示时，滚动到选中的元素
        this.scrollToActiveItem();
      }
    },
    // 监听选中的学科变化
    selectedSubject() {
      // 当选中的学科变化时，如果popover是显示的，滚动到选中的元素
      if (this.popoverVisible) {
        this.scrollToActiveItem();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.subject-selector {
  display: inline-block;
  position: relative;
}

.subject-trigger {
  cursor: pointer;
  display: flex;
  align-items: center;
  //   padding: 8px 12px;
  border-radius: 4px;

  .sel-arrow {
    font-size: 11px;
    color: #1d1b20;
    transition: transform 0.3s;
  }

  .subject-label {
    margin-right: 2px;
    color: #1d1b20;
    font-size: 14px;
  }

  .subject-label-active {
    color: #ff2020;
    & + .sel-arrow {
      color: #ff2020;
    }
  }
}

.subject-list {
  width: 114px;
  max-height: 192px;
  overflow-y: auto;
  padding: 16px;

  .subject-item {
    padding: 4px 8px;
    text-align: center;
    margin-bottom: 16px;
    background-color: #f1f3f9;
    border-radius: 20px;
    line-height: 22px;

    cursor: pointer;
    font-size: 12px;
    color: #000;
    transition: all 0.3s;

    &:hover {
      background-color: #f5f7fa;
    }

    &.active {
      background-color: #ffefef;
      color: #ff2020;
      font-weight: 500;
    }

    &.noMargin {
      margin-bottom: 0;
    }
  }
}
</style>

<style lang="scss">
/* 全局样式，确保弹出框样式正确 */
.subject-popover {
  padding: 0;
  min-width: 100px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
